<template>
	<button class="view-ui-button-skip button-secondary" v-on:click="$emit('skip')">Skip</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonSkip extends ViewBase {
		// Not implemented
	}
</script>
